import {
  processUnitSetLabelAction,
  processUnitSetValueAction,
  processSetUnitsAction
} from '@r/reducers/utils';
import { red, AllActions } from '@r/storeUtils';
import { UnitsInputv2Value } from 'decl/general/html';
import { inches } from 'decl/general/units';

export const wHeight: red<
  redux._IStore['projectFor3d']['wHeight'],
  AllActions
> = ( state = {
  label: '1' as UnitsInputv2Value,
  value: 96 as inches
}, action ) => {
  switch( action.type ) {
    case 'SET_W_HEIGHT_LABEL':
      return processUnitSetLabelAction( state, action );
    case 'SET_W_HEIGHT_VALUE':
      return processUnitSetValueAction( state, action );
    case 'SET_UNITS':
      return processSetUnitsAction( state, action );
    default:
      return state;
  }
};
